import BaseModule from '../BaseModule.js';
import { Constants } from '../Constants.js';
import CalendarDayRenderer from './CalendarDayRenderer.js';

export default {
	mixins: [BaseModule, CalendarDayRenderer],
	methods: {
		getHTML(props) {
			if (props.type === Constants.MONTHLYDAY_TYPE) {
				return this.buildHTMLMonthlyDay(props.isDisabled, props.isVacation, props.isCalendarVisible, props.calendar, props.data.workdayId, props.colors, props.hasTooltip, props.tooltip, props.tips);
			} else if (props.type === Constants.WEEKLYDAY_TYPE) {
				return this.buildHTMLWeeklyDay(props.isDisabled, props.isCalendarVisible, props.calendar, props.data.workdayId, props.projectsTextAndColor, props.dayRequests, props.data.companyNotes, props.colors, props.hasTooltip, props.tooltip, props.tips);
			} else if (props.type === Constants.HOLLYDAY_TYPE) {
				return this.buildHTMLHollyDay(props.isVacation, props.isCalendarVisible, props.calendar, props.colors, props.hasTooltip, props.tooltipText);
			}
		},
		checkIfCalendarIsVisible(calendarId) {
			const filterCalendar = localStorage.getItem('project-calendar-filter-calendar');
			if (!filterCalendar) {
					return false;
			}

			let filterCalendarIds = null;

			//console.log(`filterCalendar: ${filterCalendar}`);
			let filterCalendarItems = filterCalendar.split(';');
			//console.log(`filterCalendarItems: ${filterCalendarItems}`);
			filterCalendarItems = filterCalendarItems.filter(i => i.split(',')[1] === 'true');
			//console.log(`filterCalendarItems: ${filterCalendarItems}`);
			filterCalendarIds = filterCalendarItems.map(i => parseInt(i.split(',')[0]));
			//console.log(`filterCalendarIds: ${filterCalendarIds}`);

			return filterCalendarIds.includes(calendarId);
		},
		getVacationFilterType(vacacionLegendType, colors) {
			if (vacacionLegendType === null) {
				return false;
			}
						
			let filter_vacation_type = null;

			// mapea el tipo de legenda con el tipo de filtro
			switch (vacacionLegendType) {
				case Constants.VACATION_LEGEND_TYPE_PENDING:
					filter_vacation_type = Constants.FILTER_VACATION_TYPE_PENDING;
					break;
			
				case Constants.VACATION_LEGEND_TYPE_APPROVED:
					filter_vacation_type = Constants.FILTER_VACATION_TYPE_APPROVED;
					break;

				case Constants.VACATION_LEGEND_TYPE_PAID_ABSENCES:
					filter_vacation_type = Constants.FILTER_VACATION_TYPE_PAID_ABSENCES;
					break;

				case Constants.VACATION_LEGEND_TYPE_VACATIONS:
					filter_vacation_type = Constants.FILTER_VACATION_TYPE_VACATIONS;
					break;

				case Constants.VACATION_LEGEND_TYPE_OTHER_UNPAID_ABSENCES:
					filter_vacation_type = Constants.FILTER_VACATION_TYPE_OTHER_UNPAID_ABSENCES;
					break;
			}
			
			const existsFilter = filter_vacation_type !== null && this.existsVacationFilterInLocalStorage(filter_vacation_type);
			if (!existsFilter) {
				return false;
			}
						
			colors.push(this.getVacationLegendColor(vacacionLegendType));
			return true;
		},
		getHolidayOrRest(dayType, notes, colors, tips) {
			if (dayType === Constants.REST_DAY) {
				const existsFilter = this.existsVacationFilterInLocalStorage(Constants.FILTER_VACATION_TYPE_REST);
				if (!existsFilter) {
						return false;
				}

				colors.push('#E8F5E9'); // --> Color.GREEN_LIGHTEN_5
				tips.push(window.$vue.$t('wkt.admin.projects.calendar.renderer-helper.item.chips.rest'));
			} else if (dayType == Constants.NATIONAL_HOLIDAY || dayType === Constants.LOCAL_HOLIDAY || dayType === Constants.COMPANY_HOLIDAY) {
				const existsFilter = this.existsVacationFilterInLocalStorage(Constants.FILTER_VACATION_TYPE_HOLIDAY);
				if (!existsFilter) {
						return false;
				}
				
				colors.push('#FFE0B2'); // --> Color.ORANGE_LIGHTEN_4
				tips.push(notes === null ? window.$vue.$t('wkt.admin.projects.calendar.renderer-helper.item.chips.holiday') : notes);
			}
		},
		existsVacationFilterInLocalStorage(filter_vacation_type) {
			const filterVacation = localStorage.getItem('project-calendar-filter-vacation');
			if (!filterVacation) {
				return false;
			}
			
			let filterVacationIds = null;

			//console.log(`filterVacation: ${filterVacation}`);
			let filterVacationItems = filterVacation.split(';');
			//console.log(`filterVacationItems: ${filterVacationItems}`);
			filterVacationItems = filterVacationItems.filter(i => i.split(',')[1] === 'true');
			//console.log(`filterVacationItems: ${filterVacationItems}`);
			filterVacationIds = filterVacationItems.map(i => parseInt(i.split(',')[0]));
			//console.log(`filterVacationIds: ${filterVacationIds}`);
			const index = filterVacationIds.findIndex(v => v === filter_vacation_type);

			return index !== -1;
		},
		readProjectFiltersFromLocalStorage() {
			const filterProject = localStorage.getItem('project-calendar-filter-project');
			if (!filterProject) {
				return false;
			}
			
			let filterProjectIds = null;

			//console.log(`filterProject: ${filterProject}`);
			let filterProjectItems = filterProject.split(';');
			//console.log(`filterProjectItems: ${filterProjectItems}`);
			filterProjectItems = filterProjectItems.filter(i => i.split(',')[1] === 'true');
			//console.log(`filterProjectItems: ${filterProjectItems}`);
			filterProjectIds = filterProjectItems.map(i => parseInt(i.split(',')[0]));
			//console.log(`filterProjectIds: ${filterProjectIds}`);

			return filterProjectIds;
		},
		getVacationLegendType(recordStatus, hoursBagType) {
			let legendType = null;

			if (recordStatus !== null && recordStatus === Constants.REQUEST_PENDING) {
			// solicitud pendiente
			legendType = Constants.VACATION_LEGEND_TYPE_PENDING;
			} else if (recordStatus !== null && recordStatus === Constants.REQUEST_APPROVED) {
			// solicitud aprobada
			legendType = Constants.VACATION_LEGEND_TYPE_APPROVED;
			} else if (hoursBagType === null) {
			// ausencias retribuidas
			legendType = Constants.VACATION_LEGEND_TYPE_PAID_ABSENCES;
			} else if (hoursBagType === Constants.HOURS_BAG_VACATION_ID) {
			// vacaciones
			legendType = Constants.VACATION_LEGEND_TYPE_VACATIONS;
			} else if (hoursBagType !== Constants.HOURS_BAG_VACATION_ID) {
			// otras ausencias no retribuidas
			legendType = Constants.VACATION_LEGEND_TYPE_OTHER_UNPAID_ABSENCES;
			}

			return legendType;
		},
		getVacationLegendColor(vacationLegendType) {
			let color = null;

			switch (vacationLegendType) {
				case Constants.VACATION_LEGEND_TYPE_PENDING:
					// solicitud pendiente (amarillo)
					color = '#FFECB3'; // --> Color.AMBER_LIGHTEN_4
					break;
				case Constants.VACATION_LEGEND_TYPE_APPROVED:
					// solicitud aprobada (verde)
					color = '#B2DFDB'; // --> Color.TEAL_LIGHTEN_4;			
					break;        
				case Constants.VACATION_LEGEND_TYPE_VACATIONS:
					// vacaciones (azul)
					color = '#BBDEFB'; // --> Color.BLUE_LIGHTEN_4
					break;
				case Constants.VACATION_LEGEND_TYPE_PAID_ABSENCES:
					// ausencias retribuidas (rosa)
					color = '#FCE4EC'; // --> Color.PINK_LIGHTEN_5
					break;
				// case VACATION_LEGEND_TYPE_UNPAID_ABSENCES:
					// Ausencias no retribuidas (no tienen color asignado)
					// color = null;
					// break;
				case Constants.VACATION_LEGEND_TYPE_OTHER_UNPAID_ABSENCES:
					// otras ausencias no retribuidas (purpura)
					color = '#D1C4E9'; // --> Color.DEEP_PURPLE_LIGHTEN_4
					break;
				default:
					// desconocido
					color = '#000000'; // --> Color.BLACK
					break;
			}
			
			return color;
		},
		getMonthlyProjects(props, cb) {
			//console.log(`*** projects: ${JSON.stringify(projects)}`);
			if (props.data.projectIds === null || props.data.projectIds.length === 0) {
				//console.log(`*** projectIds: ${JSON.stringify(this.data.projectIds)}`);
				return;
			}
			
			const projectFilters = this.readProjectFiltersFromLocalStorage();
			//console.log(`*** projectFilters: ${JSON.stringify(projectFilters)}`);
			
			const projects = props.data.projectIds.split(',');

			if (projects === null || projects.length === 0) {
				//console.log(`*** projectIds: ${JSON.stringify(projectIds)}`);
				return;
			}

			let colors = [];
			let tips = [];
				
			for (let i = 0; i < projects.length; i++) {
				//console.log(`*** projects[i]: ${JSON.stringify(parseInt(projects[i]))}`);
				const project = props.projects.find(p => p.id === parseInt(projects[i]));
				
				//console.log(`*** project: ${JSON.stringify(project)}`);
				
				if (!project) continue;
				if (projectFilters.findIndex(pf => pf === project.id) === -1) continue;

				colors.push(this.convertColorToHex(project.color));
				tips.push(`${project.shortName} - ${project.description}`);
			}

			if (cb) {
				cb(colors, tips);
			}
		},
		getWeeklyProjects(props, cb) {
			//console.log(`*** projects: ${JSON.stringify(projects)}`);
			if (props.data.projectIds === null || props.data.projectIds.length === 0) {
				//console.log(`*** projectIds: ${JSON.stringify(this.data.projectIds)}`);
				return;
			}
			
			const projectFilters = this.readProjectFiltersFromLocalStorage();
			//console.log(`*** projectFilters: ${JSON.stringify(projectFilters)}`);
			
			const projects = props.data.projectIds.split(',');

			if (projects === null || projects.length === 0) {
				//console.log(`*** projectIds: ${JSON.stringify(projectIds)}`);
				return;
			}

			let textAndColor = [];
			let tips = [];
				
			for (let i = 0; i < projects.length; i++) {
				//console.log(`*** projects[i]: ${JSON.stringify(parseInt(projects[i]))}`);
				const project = props.projects.find(p => p.id === parseInt(projects[i]));
				
				//console.log(`*** project: ${JSON.stringify(project)}`);
				
				if (!project) continue;
				if (projectFilters.findIndex(pf => pf === project.id) === -1) continue;

				textAndColor.push({ text: project.shortName, color: this.convertColorToHex(project.color) });
				tips.push(`${project.shortName} - ${project.description}`);
			}

			if (cb) {
				cb(textAndColor, tips);
			}
		},
		calculateSummary(data) {
			if (!data) {
				return 0.0;
			}

			let total = 0.0;

			data.calendar.forEach(cal => {
				total += (cal.adjustmentHours !== null ? cal.adjustmentHours : 0) 
				total += (cal.totalActivityWorkHours !== null ? cal.totalActivityWorkHours : 0);
			});

			return total;
		},
	},
}
